/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Fix_Env_CommittedInputs */

const en_rd_fix_env_committed = /** @type {(inputs: Rd_Fix_Env_CommittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete committed .env files, rotate the keys, and ship a .env.example instead.`)
};

const id_rd_fix_env_committed = /** @type {(inputs: Rd_Fix_Env_CommittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus berkas .env yang ter-commit, rotasi kuncinya, dan sediakan .env.example sebagai gantinya.`)
};

/**
* | output |
* | --- |
* | "Delete committed .env files, rotate the keys, and ship a .env.example instead." |
*
* @param {Rd_Fix_Env_CommittedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_fix_env_committed = /** @type {((inputs?: Rd_Fix_Env_CommittedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Fix_Env_CommittedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_fix_env_committed(inputs)
	return en_rd_fix_env_committed(inputs)
});